import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Legend, Tooltip } from 'recharts';
import { useTheme } from '@mui/material';

interface WorkloadPieChartProps {
  cam: number;
  bim: number;
  it: number;
}

export const WorkloadPieChart: React.FC<WorkloadPieChartProps> = ({ cam, bim, it }) => {
  const theme = useTheme();

  const data = [
    { name: 'CAM', value: cam },
    { name: 'BIM', value: bim },
    { name: 'IT', value: it },
  ];

  const COLORS = [
    theme.palette.primary.main,
    theme.palette.secondary.main,
    theme.palette.info.main,
  ];

  const renderLabel = (entry: { name: string; value: number }) => {
    const total = cam + bim + it;
    const percent = total > 0 ? ((entry.value / total) * 100).toFixed(1) : 0;
    return `${entry.name}: ${percent}%`;
  };

  return (
    <ResponsiveContainer width="100%" height={300}>
      <PieChart>
        <Pie
          data={data}
          cx="50%"
          cy="50%"
          labelLine={false}
          label={renderLabel}
          outerRadius={80}
          fill="#8884d8"
          dataKey="value"
        >
          {data.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
          ))}
        </Pie>
        <Tooltip
          contentStyle={{
            backgroundColor: theme.palette.background.paper,
            border: `1px solid ${theme.palette.divider}`,
          }}
        />
        <Legend />
      </PieChart>
    </ResponsiveContainer>
  );
};
